import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary-color: #008387; /* Ajustado para o verde do site original */
    --secondary-color: #ff5252;
    --text-color: #333;
    --light-text: #fff;
    --dark-bg: #006064;
    --light-bg: #ffffff; /* Fundo branco como no site original */
    --border-radius: 8px;
    --box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    --transition: all 0.3s ease;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Roboto', sans-serif;
    line-height: 1.6;
    color: var(--text-color);
    background-color: var(--light-bg);
  }

  a {
    text-decoration: none;
    color: var(--primary-color);
    transition: var(--transition);
  }

  a:hover {
    color: var(--secondary-color);
  }

  ul {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  button {
    cursor: pointer;
    font-family: inherit;
  }

  .container {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem 0;
  }

  .section {
    padding: 4rem 0;
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from { transform: translateY(50px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  @keyframes highlight-pulse {
    0% { background-color: rgba(255, 255, 255, 0.9); }
    50% { background-color: rgba(0, 96, 100, 0.2); }
    100% { background-color: rgba(255, 255, 255, 0.9); }
  }
`;

export default GlobalStyles;
